var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5214_19404",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.896484,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5214_19404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 12.2295H8.66634V8.22949H7.33301V12.2295ZM7.99967 6.89616C8.18856 6.89616 8.3469 6.83227 8.47467 6.70449C8.60245 6.57671 8.66634 6.41838 8.66634 6.22949C8.66634 6.0406 8.60245 5.88227 8.47467 5.75449C8.3469 5.62671 8.18856 5.56283 7.99967 5.56283C7.81079 5.56283 7.65245 5.62671 7.52467 5.75449C7.3969 5.88227 7.33301 6.0406 7.33301 6.22949C7.33301 6.41838 7.3969 6.57671 7.52467 6.70449C7.65245 6.83227 7.81079 6.89616 7.99967 6.89616ZM7.99967 15.5628C7.07745 15.5628 6.21079 15.3878 5.39967 15.0378C4.58856 14.6878 3.88301 14.2128 3.28301 13.6128C2.68301 13.0128 2.20801 12.3073 1.85801 11.4962C1.50801 10.685 1.33301 9.81838 1.33301 8.89616C1.33301 7.97394 1.50801 7.10727 1.85801 6.29616C2.20801 5.48505 2.68301 4.77949 3.28301 4.17949C3.88301 3.57949 4.58856 3.10449 5.39967 2.75449C6.21079 2.40449 7.07745 2.22949 7.99967 2.22949C8.9219 2.22949 9.78856 2.40449 10.5997 2.75449C11.4108 3.10449 12.1163 3.57949 12.7163 4.17949C13.3163 4.77949 13.7913 5.48505 14.1413 6.29616C14.4913 7.10727 14.6663 7.97394 14.6663 8.89616C14.6663 9.81838 14.4913 10.685 14.1413 11.4962C13.7913 12.3073 13.3163 13.0128 12.7163 13.6128C12.1163 14.2128 11.4108 14.6878 10.5997 15.0378C9.78856 15.3878 8.9219 15.5628 7.99967 15.5628Z",
    fill: "#042354"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/infoBlue.f4b3bb191cedc77f5d68a7538e8506a9.svg";
export { ForwardRef as ReactComponent };